import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NgMaterialModule } from '../../shared/ng-material/ng-material.module';
import { FilterRoutingModule } from './filter-routing.module';
import { FilterComponent } from './filter.component';

@NgModule({
  declarations: [FilterComponent],
  imports: [
    CommonModule,
    NgMaterialModule,
    FormsModule,
    FilterRoutingModule
  ],
  exports: [FilterComponent]
})
export class FilterModule { }
